import {
  selectAllSalesTeams,
  selectAllSalesTeamsUsers,
  useGetSalesTeamListOnMount,
} from '@user/store/salesTeam'

import {
  selectAllSalesFunnels,
  useGetAllFunnelStagesOnMount,
  useGetSalesFunnelListOnMount,
  useSelectFunnelStagesByType,
} from '@user/store/salesFunnel'
import { useSelector } from 'react-redux'
import { useGetEligibleUsersForSalesTeams } from '@user/store/users/hooks/useGetEligibleUsersForSalesTeams'
import { DEFAULT_GUID_VALUE } from '@user/components/Settings/LeadAssignmentRule/constants'

export function useData(
  salesFunnelId: string,
  leadStatusId: string,
  salesTeamIds: number[],
  ownerIds: string[],
) {
  useGetSalesTeamListOnMount()
  useGetSalesFunnelListOnMount()
  useGetAllFunnelStagesOnMount()
  useGetEligibleUsersForSalesTeams(salesTeamIds)

  const salesFunnels = useSelector(selectAllSalesFunnels)
  const stages = useSelectFunnelStagesByType(+salesFunnelId, 'Lead')
  const allSalesTeams = useSelector(selectAllSalesTeams)
  const ownerList = useSelector(selectAllSalesTeamsUsers)

  const salesFunnel =
    salesFunnels?.find((item) => item.id === salesFunnelId)?.name || ''

  const salesTeams = allSalesTeams?.filter((item) =>
    salesTeamIds.includes(item.id),
  )
  const stage = stages?.find((item) => item.id === +leadStatusId)?.name || ''

  const defaultUnassignedOwner = {
    id: DEFAULT_GUID_VALUE,
    name: 'Unassigned',
    userId: 'unassigned',
    isActive: true,
  }

  const owners = ownerIds
    ? ownerIds
        .map((id: string) => {
          if (id === DEFAULT_GUID_VALUE) {
            return defaultUnassignedOwner
          }
          return ownerList?.find((item) => item.id === id)
        })
        .filter(Boolean)
    : [defaultUnassignedOwner]

  return {
    salesFunnel,
    salesTeams,
    stage,
    owners,
  }
}
